import { NotificationStatus, TargetAddress } from '../models/messageQueue/notification.data';
import { TimeHlp } from './time.helper';

/** */
export class NotificationHlp {
  /**
   * Map 'block|staircase|number'[] structure to TargetAddress table
   * @param {string[]} receivers
   * @param {boolean}  filter    true for email, false for ntf
   * @return {TargetAddress[]}
   */
  public static mapStringAddressToTargetAddress(receivers: string[], filter?: boolean): TargetAddress[] {
    const ret: TargetAddress[] = [];
    receivers.forEach((r) => {
      if (!filter || r) {
        const splitData = r.split('|');
        ret.push({ block: splitData[0] ?? '', stairway: splitData[1] ?? null, number: splitData[2] ?? null });
      }
    });
    return ret;
  }

  /**
   * Common core for all new notification data
   * @param {string} id
   * @return {Partial<NotificationQueueData>}
   */
  public static buildBasicData(id: string) {
    return {
      id,
      sendDate: Date.now(),
      status: NotificationStatus.PENDING as const,
      lastUpdate: Date.now(),
      createDate: Date.now()
    };
  }

  /**
   * Check send time; If time is today after 8:00AM - don't change, else - set at that date on 8:00 AM
   * @param {Date | number} dateFrom
   * @return {Date} news notification send time
   */
  public static getNewsSendTime(dateFrom: Date | number): Date {
    //* Notification date and time set-up
    const ntfHour = 8;

    const todaysDateNotificationTime = TimeHlp.todayAt(ntfHour); // send notification at 8:00

    let notificationDate = TimeHlp.at(dateFrom, ntfHour);

    // ? if news dateFrom is before TODAY, set notification time to TODAY 8:00AM
    if (todaysDateNotificationTime > notificationDate) {
      notificationDate = todaysDateNotificationTime;
    }

    const currentTime = new Date();
    if (currentTime.valueOf() > todaysDateNotificationTime && TimeHlp.at(notificationDate, 0) === TimeHlp.at(currentTime, 0)) {
      // ! if notification is for TODAY, and it's after 8:00, send notification right away (+/- 5 minutes, to match notification
      // queue)
      const minutes = currentTime.getMinutes() % 5;
      notificationDate = TimeHlp.add(currentTime, 5 - minutes, 'MINUTE');
    }
    return new Date(notificationDate);
  }
}
